module.exports = __webpack_public_path__ + "img/img_disease1.192235d1.jpg";